import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  xsCell: {
    width: '60px'
  },
  smCell: {
    width: '80px'
  },
  mdCell: {
    width: '100px'
  },
  lgCell: {
    width: '120px'
  },
  residentCell: {
    width: '200px'
  },
  balanceCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  greyText: {
    color: palette.shades[500]
  },
  statusInfo: {
    display: 'flex',
    '& .MuiTypography-root': {
      marginLeft: '10px'
    }
  },
  checkboxCell: {
    '& path': {
      fill: palette.shades[300]
    }
  },
  cellRight: {
    '& .cellContent': {
      padding: '10px',
      justifyContent: 'flex-end'
    }
  },
  cellContent: {
    borderRadius: '2px',
    transition: "all ".concat(palette.transitions.short),
    width: '100%',
    height: '36px',
    display: 'flex',
    padding: '10px 6px',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: palette.shades[300],
      cursor: 'pointer'
    }
  },
  disabledCellText: {
    color: palette.shades[500],
    padding: '10px 6px'
  },
  disabledClick: {
    pointerEvents: 'none'
  },
  cellLeftAlign: {
    justifyContent: 'flex-start !important'
  },
  formerTableRow: {
    position: 'relative'
  }
});
export default useStyles;